import { get, post, put, dlt, getBlob } from './Api';
const endpoint = 'boms';

export const openBom = async jobId => await get(`${endpoint}/job/${jobId}`);
export const getById = async id => await get(`${endpoint}/${id}`);
export const createBomItem = async data => await post(`${endpoint}/item`, data);
export const updateBomItem = async data => await put(`${endpoint}/item`, data);
export const deleteBomItem = async id => await dlt(`${endpoint}/item/${id}`);